import { useEffect } from "react";
import PropTypes from "prop-types";

import { useSelector, useDispatch } from "react-redux";
import { setStickyHeaderMenuItems } from "@/src/store/listingDetail";
// import { fetchInstallementList } from "@/src/store/creditCalculation";

import { trackListingViewAction } from "@/src/utils/actions-tracker";
// import { AKBANK_ELIGIBLE_ESTATE_TYPES } from "@/src/utils/constants/listing-detail";

import QuickInfo from "components/listing-detail/quick-info";
import JetFirsatBanner from "components/listing-detail/jetfirsat-banner";
import ContentOuterWrap from "components/listing-detail/content-outer-wrap";
import InfoList from "components/listing-detail/info-list";
// import Description from "components/listing-detail/description";
import NewDescription from "components/listing-detail/description/newDescription";
import PropertiesListWrap from "components/listing-detail/properties-list-wrap";
import LocationInfoWrap from "components/listing-detail/location-info-wrap";
import PreviousPrices from "components/listing-detail/previous-prices";
import RegionReport from "components/listing-detail/region-report";
import CompanyBadge from "components/listing-detail/company-badge";
// import AdditionalBenefits from "components/listing-detail/additional-benefits";
import CompanyBadgeSidebar from "components/listing-detail/company-badge/sidebar";
import EstateOfficeAvailability from "components/listing-detail/estate-office-availability";
// import { CreditCalculationRightColumn } from "@/src/components/housing-credit/listing-detail-right-column/CreditCalculationRightColumn";
import SidebarList from "components/listing-detail/sidebar-list";
import SimilarRealEstateList from "components/listing-detail/similar-real-estate-list";
// import AkbankBanner from "@/src/components/listing-detail/akbank-banner";
import dynamic from "next/dynamic";
import AkbankBanner from "../akbank-banner-between-nearby-and-price";

// import { isVisibleAkbankWidget } from "@/src/components/housing-credit/commons/helpers/index";

import styles from "./styles.module.css";

const GptAd = dynamic(() => import("components/gpt-ad-element"), { ssr: false });


const ContentWrapper = ({ data, similarRealEstateList, listingPriceHistory: priceHistories }) => {
  const dispatch = useDispatch();
  const { stickyHeaderMenuItems: reduxStickyMenuItems } = useSelector((state) => state.listingDetail || {});
  const {
    priceDetail,
    properties,
    description,
    owner,
    id,
    attributes,
    endeksaValuation,
    districtReportPriceInfos,
    districtReportDemographicInfos,
    tradeType,
    location,
    similarData,
  } = data || {};

  const infoPropertyCategory = properties?.find((property) => property.key === "category");
  const listingEstateType = data?.properties?.filter((item) => item.key === "category")[0].value;
  const isJetFirsatListing = priceDetail?.opportunity && infoPropertyCategory.value !== "Arsa";

  const endeksaEstateTypes = ["Konut", "İşyeri", "Arsa"];
  const isVisibleEndeksaSection =
    endeksaEstateTypes.includes(listingEstateType) && (districtReportPriceInfos || districtReportDemographicInfos);

  // const visibilityStateForAkbank = isVisibleAkbankWidget(data);

  const visibilityStateForJettasin = ["sale", "rent"].includes(tradeType.key) && [2, 6].includes(tradeType.typeId);
  const isDailyRentPage = tradeType?.key === "daily_rent";
  const isLandRentPage = tradeType?.key === "rent" && tradeType?.typeId === 5;

  const showAkbankBanner = tradeType?.key === "rent" && !isDailyRentPage && !isLandRentPage;

  const isSale = tradeType?.key === "sale";
  const isRent = tradeType?.key === "rent";
  const showSecondaryAkbankBanner = ["Konut"].includes(listingEstateType) && (isSale || isRent);

  const isOfficeAvailabilityVisible = () => {
    const now = new Date();
    const currentHour = now.getHours();
    const isCorporate = owner?.account?.type === "corporate";
    const isWithinWorkingHours = currentHour >= 9 && currentHour < 22;
    const isPilotArea = location.city.name === "Konya" || location.city.name === "Aydın";

    return isCorporate && isWithinWorkingHours && isPilotArea;
  };

  useEffect(() => {
    if (
      owner?.account?.type !== "corporate" &&
      reduxStickyMenuItems?.filter((x) => x.key === "firma-kunyesi").length > 0
    ) {
      const menuItemsFiltered = reduxStickyMenuItems?.filter((x) => x.key !== "firma-kunyesi");
      dispatch(setStickyHeaderMenuItems(menuItemsFiltered));
    }
    if (!visibilityStateForJettasin || !isVisibleEndeksaSection) {
      const visibilityMap = {
        "bolge-raporu": !!isVisibleEndeksaSection,
        "ek-faydalar": !!visibilityStateForJettasin,
      };

      const filteredStickyItems = reduxStickyMenuItems?.filter((item) => visibilityMap[item.key] !== false);
      dispatch(setStickyHeaderMenuItems(filteredStickyItems));
    }
    const hasPriceHistory = priceHistories?.length > 0;
    const hasEndeksaPrice =
      priceDetail?.price <= endeksaValuation?.maxPrice && !!endeksaValuation?.minPrice && !!endeksaValuation?.maxPrice;
    if (!hasPriceHistory && !hasEndeksaPrice) {
      const filtered = reduxStickyMenuItems.filter((item) => item.key !== "fiyat-analizi");
      dispatch(setStickyHeaderMenuItems(filtered));
    }
    // dispatch(fetchInstallementList());
    trackListingViewAction({ actionName: "lv", baseUrl: id });
  }, []);

  return (
    <div className={styles.wrapper} id="genel-bakis" data-scroll-selector>
      <div className={styles.contentWrap}>
        <QuickInfo data={data} showAkbankBanner={showAkbankBanner} />
        {isJetFirsatListing && <JetFirsatBanner />}
        <ContentOuterWrap id="ilan-hakkinda">
          <InfoList data={properties} isDailyRentPage={isDailyRentPage} />
          <NewDescription data={description} jethat={owner?.account?.phoneNumber} listingId={id} />
          {attributes && Object.keys(attributes).length ? <PropertiesListWrap data={attributes} /> : null}
        </ContentOuterWrap>
        <LocationInfoWrap data={data} />
        <PreviousPrices
          min={endeksaValuation?.minPrice || null}
          max={endeksaValuation?.maxPrice || null}
          current={priceDetail?.price || null}
          isJetFirsatListing={isJetFirsatListing}
          townName={data?.location?.town?.name}
          priceHistory={priceHistories}
        />
        {isVisibleEndeksaSection && (
          <RegionReport
            listingData={data}
            districtReportPriceInfos={districtReportPriceInfos}
            districtReportDemographicInfos={districtReportDemographicInfos}
          />
        )}
        <div id="akbank-banner" data-scroll-selector>
          {showSecondaryAkbankBanner && <AkbankBanner />}
        </div>
        {owner?.account?.type === "corporate" ? <CompanyBadge data={owner} similarData={similarData} /> : null}
        {/* {visibilityStateForJettasin && <AdditionalBenefits />} */}
        {similarRealEstateList?.length > 0 && <SimilarRealEstateList similarRealEstateList={similarRealEstateList} />}
      </div>
      <div className={styles.sidebarWrap}>
        {isOfficeAvailabilityVisible() && <EstateOfficeAvailability />}
        <CompanyBadgeSidebar data={data} />
        {/* {visibilityStateForAkbank && <CreditCalculationRightColumn />} */}
        <SidebarList />
        <div className={styles.adLine}>
          <GptAd elementId="div-gpt-ad-1568113922617-0" />
        </div>
      </div>
    </div>
  );
};

ContentWrapper.propTypes = {
  data: PropTypes.any,
  similarRealEstateList: PropTypes.array,
  listingPriceHistory: PropTypes.array,
};

export default ContentWrapper;
